export interface CountryType {
  code: string;
  label: string;
  phone: string;
  suggested?: boolean;
}

// From https://bitbucket.org/atlassian/atlaskit-mk-2/raw/4ad0e56649c3e6c973e226b7efaeb28cb240ccb0/packages/core/select/src/data/countries.js
export const COUNTRIES: readonly CountryType[] = [
  { code: 'AD', label: 'Andorra', phone: '376' },
  { code: 'AE', label: 'United Arab Emirates', phone: '971' },
  { code: 'AF', label: 'Afghanistan', phone: '93' },
  { code: 'US', label: 'United States', phone: '1', suggested: true },
  { code: 'IN', label: 'India', phone: '91' },
  { code: 'GB', label: 'United Kingdom', phone: '44' },
  { code: 'CA', label: 'Canada', phone: '1', suggested: true },
  { code: 'AU', label: 'Australia', phone: '61', suggested: true },
  { code: 'DE', label: 'Germany', phone: '49', suggested: true },
  { code: 'FR', label: 'France', phone: '33', suggested: true },
  { code: 'JP', label: 'Japan', phone: '81', suggested: true },
  { code: 'CN', label: 'China', phone: '86' },
  { code: 'BR', label: 'Brazil', phone: '55' },
  { code: 'MX', label: 'Mexico', phone: '52' },
  { code: 'IT', label: 'Italy', phone: '39' },
  { code: 'ES', label: 'Spain', phone: '34' },
  { code: 'KR', label: 'Korea, Republic of', phone: '82' },
  { code: 'RU', label: 'Russian Federation', phone: '7' },
  { code: 'NL', label: 'Netherlands', phone: '31' },
  { code: 'SE', label: 'Sweden', phone: '46' },
  { code: 'CH', label: 'Switzerland', phone: '41' },
  { code: 'NO', label: 'Norway', phone: '47' },
  { code: 'DK', label: 'Denmark', phone: '45' },
  { code: 'FI', label: 'Finland', phone: '358' },
  { code: 'BE', label: 'Belgium', phone: '32' },
  { code: 'AT', label: 'Austria', phone: '43' },
  { code: 'IE', label: 'Ireland', phone: '353' },
  { code: 'NZ', label: 'New Zealand', phone: '64' },
  { code: 'SG', label: 'Singapore', phone: '65' },
  { code: 'HK', label: 'Hong Kong', phone: '852' },
  { code: 'ZA', label: 'South Africa', phone: '27' },
  { code: 'AR', label: 'Argentina', phone: '54' },
  { code: 'CL', label: 'Chile', phone: '56' },
  { code: 'CO', label: 'Colombia', phone: '57' },
  { code: 'PE', label: 'Peru', phone: '51' },
  { code: 'VE', label: 'Venezuela', phone: '58' },
  { code: 'UY', label: 'Uruguay', phone: '598' },
  { code: 'PY', label: 'Paraguay', phone: '595' },
  { code: 'BO', label: 'Bolivia', phone: '591' },
  { code: 'EC', label: 'Ecuador', phone: '593' },
  { code: 'LK', label: 'Sri Lanka', phone: '94' },
  { code: 'BD', label: 'Bangladesh', phone: '880' },
  { code: 'PK', label: 'Pakistan', phone: '92' },
  {code: 'SA', label: 'Saudi Arabia', phone: '966'},
  {code: 'MY', label: 'Malaysia', phone: '60'},
  {code: 'PH', label: 'Philippines', phone: '63' }
];
